import { Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { properlizeWords } from "../../helpers";
import { IAuthState } from "../../stateManagement/reducers/authReducer";
import {
  IStaff,
  IStaffsState,
  tryFetchStaffs,
} from "../../stateManagement/reducers/staffsReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import IconText from "../IconText";

interface IStaffsMenuProps {
  staffRole?: string;
  reAssigning?: boolean;
  setStaff: (staff: IStaff) => void;
}

const StaffsMenu: React.FC<IStaffsMenuProps> = ({
  setStaff,
  reAssigning,
  staffRole,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useDispatch<any>();

  const { authToken } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );
  const { fetchingStaffs, staffs } = useSelector<IRootReducerT, IStaffsState>(
    (state) => state.staffs,
  );

  useEffect(() => {
    dispatch(
      tryFetchStaffs({
        authToken: authToken ?? "",
      }),
    );
  }, []);

  return (
    <div>
      <Button
        id="drivers-menu-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        color="primary"
        size="medium"
        onClick={handleClick}
      >
        {reAssigning && `Assign another ${staffRole ?? "Tutor"}`}
        {!reAssigning && `Assign ${staffRole ?? "Tutor"}`}
      </Button>
      <Menu
        id="drivers-positioned-menu"
        aria-labelledby="drivers-menu-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ zIndex: 1400000000000000000, position: "absolute" }}
      >
        <Typography p={0.5} variant="body1" color="secondary">
          Select {`${staffRole ?? "Tutor"}`}
        </Typography>
        {staffs.length > 0 &&
          staffs
            .filter(
              (mainStaff) => !staffRole || mainStaff.role?.name === staffRole,
            )
            .map((staff) => {
              return (
                <MenuItem
                  onClick={(e) => {
                    setStaff(staff);
                    handleClose();
                  }}
                >
                  <IconText
                    iconSrc={staff?.imgSrc ?? ""}
                    topText={properlizeWords(
                      `${staff.firstName} ${staff.lastName}`,
                    )}
                    bottomText={staff.email}
                  />
                  <Grid
                    container
                    spacing={0.5}
                    direction="column"
                    ml={5}
                    justifyContent="center"
                    alignItems={"flex-end"}
                  >
                    <Grid color="secondary" item xs="auto">
                      <Typography variant="body2" color="textSecondary">
                        {`${
                          (staff?.pendingOrdersCount ?? 0) +
                          (staff?.orderRequestsCount ?? 0) +
                          (staff?.pendingServicesPlansCount ?? 0) +
                          (staff?.servicesPlansRequestsCount ?? 0)
                        } assigned tasks`}
                      </Typography>
                    </Grid>
                  </Grid>
                </MenuItem>
              );
            })}
        {staffs.length === 0 && fetchingStaffs && (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <Typography
                variant="body2"
                color="secondary"
                p={1}
                sx={{ fontWeight: 400, textAlign: "center" }}
              >
                Loading...
              </Typography>
            </Grid>
          </Grid>
        )}
        {staffs.length === 0 && !fetchingStaffs && (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <Typography
                variant="body2"
                color="secondary"
                p={1}
                sx={{ fontWeight: 400, textAlign: "center" }}
              >
                No Staff Yet.
              </Typography>
            </Grid>
          </Grid>
        )}
      </Menu>
    </div>
  );
};

export default StaffsMenu;
